import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';

function Overview() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>

            <h2>Convocation - 2024 Updates</h2> 
            <Row className='mb-5  mt-5 text-center'>

                <Col md={6}  className="mb-3">
                    <Button className='btn-lg c-fontsize14 me-2'>
                        <a href="https://www.youtube.com/watch?v=c09BRodJSvM" target='_blank' className='text-white'  >
                            Youtube streaming 
                            (For External Users)</a></Button>

                </Col>

                <Col md={6} className="mb-3">
                    <Button className='btn-lg c-fontsize14' >
                        <a href="http://live.iittp.ac.in/" target='_blank' className='text-white'  >
                            LAN streaming
                            (For External Users)</a></Button>
                </Col>
            </Row>

            <ul className='myulcustarrow c-lineheight2dot5 fw-bold'>

                <li><Link to="https://files.iittp.ac.in/pdfs/convocation/2024/Convocation-Brochure.pdf" target="_blank"> Click here to view Convocation Brochure - 2024</Link></li>
                <li><Link to="https://www.iittp.ac.in/convocation2024/" target="_blank"> For more Details</Link></li>
                <li>4th and 5th (Joint) Convocation will be held on 22.02.2024 at IIT Tirupati Campus.Shri Dharmendra Pradhan ji (Hon'ble Education Minister, GoI) will be the Chief Guest for the convocation and our Chairman, Board of Governors, Shri Sajjan Jindal (Chairman & Managing Director, JSW Group) will preside over the ceremony</li>
                <li> Google form link for registration for 4th & 5th (Joint) Convocation:<Link to="https://forms.gle/HJK7e9wjHhvjHjARA" target="_blank"> Click Here</Link></li>
            </ul>


            
        </div>
    );
}

export default Overview;
